import { LicenseTypeEnum } from "./Models";

export type LicenseValue = {
    typeId: LicenseTypeEnum;

    name: string;
    description: string;
    isSelfHosted: boolean;
    isSupportsSeats: boolean;
    isConfigurable: boolean;
    maxRequestsPerTimeWindow: number;

    maxCpuTimeInMin?: number;
    minCpuTimeInMin: number;
    isCalibratingEnabled: boolean;
    maxCountOfSchemas?: number;
    minCountOfSchemas: number;

    maxCountOfModels?: number;
    minCountOfModels: number;
    maxCountModelsInQueue: number;

    maxDatasetSizeForSchemaMb?: number;
    minDatasetSizeForSchemaMb: number;
    maxNumberOfFeatures: number;

    defaultCpuTimeInMinutes?: number;
    defaultCountOfSchemas?: number;
    defaultCountOfModels?: number;
    defaultDatasetSizeForSchemaMb?: number;
    numberOfInstances: number;
}

export type LicenseConfiguration = {
    typeId: LicenseTypeEnum;
    expirationType: LicenseExpirationTypeEnum;
    cpuTimeInMinutes: number;
    isCalibratingEnabled: boolean;
    countOfSchemas: number;
    countOfModels: number;
    numberOfFeatures: number;
    datasetSizeForSchemaMb: number;
    numberOfSeats: number;
    numberOfInstances: number;
}

export enum LicenseExpirationTypeEnum {
    Month = "Month",
    Year = "Year"
}

export type LicensePrices = {
    usd: number
}